import React, { useState } from 'react';
import styled from 'styled-components';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { sendRequest, API_ROOT } from '../supplementary_components/requests';
import { addNotification } from '../supplementary_components/store';
import { localDateToUSFormat } from '../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection';
import { useBoardStore } from './boardStore';

const DateSelectButton = styled.div`
    top:42%;
    // margin: 0 0.2rem;
    position:absolute;
    right:${props=>props.$right ? 0 : ""};
    &>svg{
        color: var(--light-gray);
        cursor:pointer;
        :hover{
            color: var(--gray);
        }
    }
    &>span{
        position:absolute;
        top:-1.3rem;
        ${props=>props.$right ? `
            left:-0.35rem;
            background-color:var(--lighter-gray);
            color:var(--light-gray);
        ` : `
            left: 0.25rem;
            background-color:rgba(var(--lightAlertRGB), 0.3);
            color:var(--lightAlert);
        `};
        // right:0.25rem;
        // margin: 0 0.25rem;
        
        
        font-size:0.8rem;
        font-weight:800;
        border-radius:100rem;
        padding: 0.1rem 0.35rem;
    }

`;
const UnassignedLoadsTableWrapper = styled.div`
    width:100%;
    min-height:5.5rem;
    background-color:var(--extra-light-gray);
    margin-bottom:0.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    &>div:not(:first-child){
        box-shadow:var(--left);
    }
    &>div:first-child{
        padding-left:1.2rem;
    }
    &>div:last-child{
        padding-right:1rem;
    }
    &>div{
        padding-bottom:0.3rem;
        overflow:hidden;
        &>div:first-child{ // label
            padding:0.2rem 0;
            color: var(--light-gray);
            font-size:0.7rem;
            text-align:center;
        }
        &>div:not(:first-child){
            &.notUrgent{
                color:var(--light-gray);
                background-color:var(--lighter-gray);
            }
            &:not(.notUrgent){
                color:var(--alertTextColor);
                background:var(--mainBoardAlertsBg);
            }
            
            
            font-weight:700;
            font-size:0.85rem;
            max-width : 35%;
            overflow:hidden;
            display:inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0.3rem 0.6rem;
            border-radius:0.2rem;
            margin-left: 0.4rem;
            margin-top:0.1rem;
            cursor:pointer;
            text-decoration:underline;
            
        }
    }
`

export const UnassignedLoadsTable = () => {
    const unassignedLoadsList = useBoardStore(s => s.unassignedLoads) || [];
    const setPopupRaw = useBoardStore(s => s.setPopupRaw);
    const openPopupLoad = useBoardStore(s => s.openPopupLoad);
    const upsertLoad = useBoardStore(s => s.upsertLoad);
    const [selectedDate, setSelectedDate] = useState(() => {
        const live = useBoardStore.getState().getLiveCurrentTime?.();
        const seed = live || null;
        if (seed) {
            const day = seed.startOf('day').minus({ days: 1 });
            return new Date(day.year, day.month - 1, day.day);
        }
        const initDate = new Date();
        initDate.setDate(initDate.getDate() - 1);
        initDate.setHours(0, 0, 0, 0);
        return initDate;
    });
    
    function changeDate(increase){
        const newDate = new Date(selectedDate);
        newDate.setDate(newDate.getDate() + (increase?1:(-1)));
        setSelectedDate(newDate);
    }
    const loadsOutsideOfTable = {
        loadsToleft: 0,
        loadsToRight: 0
    };
    const tableData = {}
    Array(6).fill(0).forEach((val, index)=>{
        const lblDate = new Date(selectedDate);
        
        lblDate.setDate(lblDate.getDate() + index);
        const month = String((lblDate.getMonth() + 1)).padStart(2, '0'); // getMonth() is 0-indexed, so add 1
        const day = String((lblDate.getDate())).padStart(2, '0'); 
        const year = String((lblDate.getFullYear())).slice(-2);
        tableData[`${month}/${day}/${year}`] = []
    });
    
    for(const load of unassignedLoadsList){
        const startDate = new Date(selectedDate);
        startDate.setHours(0,0,0,0);
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate()+5);
        const loadsStartDate = new Date(load.startDate+"T00:00");
        if(loadsStartDate < startDate){
            loadsOutsideOfTable.loadsToleft += 1;
        }else if(loadsStartDate > endDate){
            loadsOutsideOfTable.loadsToRight += 1;
        }else{
            const parsedDate = localDateToUSFormat(load.startDate)
            if(tableData[parsedDate]){
                tableData[parsedDate].push(load);
            }
        }
    }
    const liveToday = useBoardStore.getState().getLiveCurrentTime?.();
    const today = liveToday
        ? new Date(liveToday.year, liveToday.month - 1, liveToday.day)
        : (() => {
            const d = new Date();
            d.setHours(0, 0, 0, 0);
            return d;
        })();
    return <div style={{position:"relative"}}>
        <DateSelectButton onClick={()=>{changeDate(false)}}>
            {loadsOutsideOfTable.loadsToleft > 0 ? <span>{loadsOutsideOfTable.loadsToleft}</span>:null}
            <FaChevronLeft />
        </DateSelectButton>
        <DateSelectButton onClick={()=>{changeDate(true)}} $right={true}>
            {loadsOutsideOfTable.loadsToRight > 0 ? <span>{loadsOutsideOfTable.loadsToRight}</span>:null}
            <FaChevronRight />
        </DateSelectButton>
        <UnassignedLoadsTableWrapper>
            {
                Object.entries(tableData).map((weekDay, index) =>{
                    // const componentsArray =weekDay[0].substr(weekDay[0].indexOf('-')+1).split('-')
                    // const formattedDate = `${componentsArray[0]}/${componentsArray[1]}`;
                    
                    const columnDate = new Date(selectedDate);
                    columnDate.setDate(columnDate.getDate() + index);
                    columnDate.setHours(0, 0, 0, 0);
                    const daysFromToday = Math.floor((columnDate - today) / (1000 * 60 * 60 * 24));
                    return <div key={index}>
                        <div className="non-selectable">
                            {weekDay[0].slice(0, 5)}
                        </div>
                        {
                            weekDay[1].map((load, indx)=> {                                
                                return <div className={daysFromToday > 1 ? "notUrgent" : ""} key={indx} onClick={()=>{
                                    setPopupRaw({loadNumber:true, loading:true});
                                    sendRequest('GET', `${API_ROOT}loads/${load.id}`, null, (resp)=>{
                                        try { upsertLoad(resp); } catch (e) {}
                                        openPopupLoad(resp?.id || load.id);
                                    }, ()=>{addNotification({message:`Something went wrong`, type:'alert'})}, null);
                                }}>
                                    {`${load.startCityState && load.endCityState ? `${extractStateStr(load.startCityState)}-${extractStateStr(load.endCityState)} `:''}${load.loadNumber}`}
                                </div>
                            })
                        }
                    </div>
                })
            }
        </UnassignedLoadsTableWrapper>
    </div>
}

export function extractStateStr(cityState){
    try {
        if(!cityState)return "/";
        const arr = cityState.split(", ");
        return arr[1];
    } catch (error) {
        return  "/";
    }
}